import React, { useContext } from 'react'
import {
    Typography,
    Box,
} from '@mui/material'

import { AppContext } from './../../context/context/context.js'

import data from './../../data/about.json'

const About = () => {
    const { state } = useContext(AppContext)

    return (
        <Box
            mt={5}
            padding={"0 5%"}>
            <Typography
                variant='span'
                color={state.color.secondary}
                fontSize={{ xs: 26, md: 40 }}
            >
                {data.data}
            </Typography>
        </Box >
    )
}

export default About